import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

function SearchResultsList({ listRef, filteredItems, activeIndex, handleSelect }) {
	return (
		<Box ref={listRef} sx={{ padding: '8px', paddingY: '10px' }}>
			{filteredItems.length === 0 && (
				<Box
					sx={{
						padding: '24px 16px',
						textAlign: 'center',
						color: '#9e9e9e'
					}}
				>
					<Typography variant="body2">No matching settings found</Typography>
				</Box>
			)}
			{filteredItems.map((item, index) => (
				<Box
					key={item.settingName}
					data-index={index}
					onClick={() => handleSelect(item.settingName)}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						padding: '10px 12px',
						cursor: 'pointer',
						borderRadius: '8px',
						backgroundColor: index === activeIndex ? 'rgba(239, 83, 80, 0.08)' : 'transparent',
						transition: 'background-color 0.15s ease',
						'&:hover': {
							backgroundColor:
								index === activeIndex ? 'rgba(239, 83, 80, 0.12)' : 'rgba(0, 0, 0, 0.04)'
						}
					}}
				>
					<Box>
						<Typography
							variant="body2"
							sx={{
								fontWeight: index === activeIndex ? 600 : 400,
								color: index === activeIndex ? '#EF5350' : '#333',
								fontSize: '14px'
							}}
						>
							{item.label}
						</Typography>
						{item.group && (
							<Typography
								variant="caption"
								sx={{
									color: '#9e9e9e',
									fontSize: '12px',
									display: 'block',
									marginTop: '1px'
								}}
							>
								{item.group}
							</Typography>
						)}
					</Box>
					{index === activeIndex && (
						<KeyboardReturnIcon sx={{ fontSize: '16px', color: '#9e9e9e', flexShrink: 0 }} />
					)}
				</Box>
			))}
		</Box>
	);
}

export default SearchResultsList;
